import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/acteursevents`;

const getAuthConfig = () => {
  const token = localStorage.getItem("token");

  if (!token || token === "null" || token === "undefined") {
    throw new Error("Aucun token d'authentification valide n'est disponible.");
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

/// GET

// Fonction pour afficher tous les inscriptions, notes et observations
export const getAllResults = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allresults`, getAuthConfig());
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des inscriptions:", error);
    return [];
  }
};

// Fonction pour afficher tous les acteurs d'un événement
export const getAllActorsByEventId = async (eventId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getActeursByEventId/${eventId}`,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des acteurs de l'événement:",
      error,
    );
    return [];
  }
};

// Fonction pour afficher tous les événements d'un acteur
export const getAllEventsByActorId = async (acteurId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getEventsByActeurId/${acteurId}`,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des événements de l'acteur:",
      error,
    );
    return [];
  }
};

// Fonction pour récupérer une relation acteur/événement précise
export const getActeurEventById = async (acteurId, eventId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getActeurEventById/${acteurId}/${eventId}`,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement du détail acteur/événement :",
      error,
    );
    throw error;
  }
};

// Fonction pour récupérer les convocations de l'utilisateur connecté
export const getMyConvocations = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/myConvocations`,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des convocations :", error);
    throw error;
  }
};

// Fonction pour récupérer les demandes de prise en charge d'un événement
export const getSupportRequestsByEventId = async (eventId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getSupportRequestsByEventId/${eventId}`,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des demandes de prise en charge :",
      error,
    );
    throw error;
  }
};

/// POST

// Fonction pour ajouter un acteur à un événement
export const assignActorToEvent = async (
  acteurId,
  eventId,
  poste = null,
  tapis = null,
) => {
  try {
    const response = await axios.post(
      `${apiUrl}/assignActorToEvent`,
      {
        acteur_id: acteurId,
        event_id: eventId,
        poste,
        tapis,
      },
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'acteur à l'événement:", error);
    throw error;
  }
};

// Variante plus souple si tu veux envoyer un objet complet
export const assignActorToEventWithData = async (data) => {
  try {
    const response = await axios.post(
      `${apiUrl}/assignActorToEvent`,
      data,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'acteur à l'événement:", error);
    throw error;
  }
};

/// PUT

// Fonction pour mettre à jour les informations d'un acteur d'un événement
export const updateActorEvent = async (acteurId, eventId, data) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateActeurInEvent/${acteurId}/${eventId}`,
      data,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour des informations de l'acteur:",
      error,
    );
    throw error;
  }
};

// Fonction pour mettre à jour l'affectation poste / tapis
export const updateActorAssignment = async (acteurId, eventId, data) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateAssignment/${acteurId}/${eventId}`,
      data,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de l'affectation :", error);
    throw error;
  }
};

// Fonction pour mettre à jour la prise en charge transport / hébergement
export const updateSupportStatus = async (acteurId, eventId, data) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateSupportStatus/${acteurId}/${eventId}`,
      data,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour du statut de prise en charge :",
      error,
    );
    throw error;
  }
};

// Fonction pour mettre à jour la présence réelle
export const updateAttendance = async (
  acteurId,
  eventId,
  attendance_status,
) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateAttendance/${acteurId}/${eventId}`,
      { attendance_status },
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de la présence :", error);
    throw error;
  }
};

// Fonction pour mise à jour en lot des affectations
export const bulkUpdateAssignments = async (eventId, assignments) => {
  try {
    const response = await axios.put(
      `${apiUrl}/bulkUpdateAssignments/${eventId}`,
      assignments,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour en lot des affectations :",
      error,
    );
    throw error;
  }
};

export const syncActorsSelectionForEvent = async ({
  eventId,
  acteurIds,
  scopeActeurIds,
  poste,
  tapis,
}) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/syncActorsSelectionForEvent`,
      {
        event_id: eventId,
        acteur_ids: acteurIds,
        scope_acteur_ids: scopeActeurIds,
        poste,
        tapis,
      },
      getAuthConfig(),
    );

    return data;
  } catch (error) {
    console.error("Erreur syncActorsSelectionForEvent:", error);
    throw error;
  }
};

// Fonction pour toggle la validation d'un acteur sur un événement
export const toggleActeurValidation = async (acteurId, eventId) => {
  try {
    const response = await axios.put(
      `${apiUrl}/toggleValidation/${acteurId}/${eventId}`,
      {},
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la validation de l'acteur:", error);
    throw error;
  }
};

// Fonction pour répondre à une convocation
export const respondToConvocation = async (
  acteurId,
  eventId,
  responseStatus,
  responseReason = "",
  extraData = {},
) => {
  if (!acteurId) {
    throw new Error("L'identifiant du profil acteur est obligatoire.");
  }

  if (!eventId) {
    throw new Error("L'identifiant de l'événement est obligatoire.");
  }

  try {
    const response = await axios.put(
      `${apiUrl}/respondToConvocation/${acteurId}/${eventId}`,
      {
        response_status: responseStatus,
        response_reason: responseReason,
        ...extraData,
      },
      getAuthConfig(),
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la réponse à la convocation :", {
      status: error?.response?.status,
      message:
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message,
      acteurId,
      eventId,
    });

    throw error;
  }
};

/// DELETE

// Fonction pour supprimer un acteur d'un événement
export const deleteActorFromEvent = async (acteurId, eventId) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/removeActeurFromEvent/${acteurId}/${eventId}`,
      getAuthConfig(),
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la suppression de l'acteur de l'événement:",
      error,
    );
    throw error;
  }
};
